module.exports = __webpack_public_path__ + "img/continental-logo.4d5cf00d.png";